/**
 * /validation — release validation: the runs, and the risk assessment that
 * starts one.
 *
 * The assessment was a separate destination living under `/ai/`, which put the
 * first stage of the journey in a different part of the product from the rest
 * of it. It is the same subject, so it is a tab.
 *
 * **Each tab keeps its own URL** (`/validation/runs`,
 * `/validation/risk-assessment`), so a link still lands on the right one.
 * `/ai/risk-assessment` redirects — links to it are already in circulation.
 *
 * The two differ in role: runs are Developer+ (they spend model tokens, read a
 * vault, and end in a GxP sign-off); the assessment is not. The route guards
 * are per-tab and unchanged — this only hides a tab the viewer would be
 * refused, rather than offering one that 403s.
 */

import { Stack, Title } from "@mantine/core";

import { RiskAssessment } from "@/features/ai/RiskAssessment";

export type ValidationTab = "runs" | "risk-assessment";

export function ValidationHub({ tab: _tab }: { tab: ValidationTab }) {
  // Release validation is the risk assessment only (product decision
  // 2026-10-02): the Runs tab is gone. `/validation/runs` still routes here so
  // links in circulation land on the assessment.
  return (
    <Stack gap="md">
      <Title order={2}>Release risk assessment</Title>
      <RiskAssessment />
    </Stack>
  );
}
